/*
 * Permedio – Custom GA4 / Google Ads / Meta Events
 * Portiert vom alten Theme "Permedio_Genetik" auf Symmetry (Brandpiloten, Okt. 2026)
 *
 * Änderungen ggü. Original:
 *  - Init nicht nur bei "visitorConsentCollected", sondern auch bei bereits vorhandener Einwilligung (wiederkehrende Besucher)
 *  - gtag wird bei Bedarf selbst geladen (G-KNV70TT8VL + AW-11341536800, ohne page_view → keine Doppelzählung mit Google-&-YouTube-App)
 *  - Selektoren an Symmetry angepasst (Warenkorb-Template, Newsletter-Formular)
 */
(function () {
  var GA4_ID = "G-KNV70TT8VL";
  var ADS_ID = "AW-11341536800";
  var initialized = false;

  function cp() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }
  function analyticsOk() {
    try { return !!(cp() && cp().analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  function marketingOk() {
    try { return !!(cp() && cp().marketingAllowed()); } catch (e) { return false; }
  }

  function ensureGtag() {
    if (typeof window.gtag === "function") return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA4_ID;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
    window.gtag("config", ADS_ID);
  }

  function tryInit() {
    if (initialized || !cp()) return;
    if (!analyticsOk() && !marketingOk()) return;
    initialized = true;
    ensureGtag();
    dwInitEvents();
  }

  // 1) Einwilligung wird gerade erteilt
  document.addEventListener("visitorConsentCollected", tryInit);

  // 2) Einwilligung liegt bereits vor (wiederkehrende Besucher)
  function boot() {
    if (cp()) return tryInit();
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        if (!err) tryInit();
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function dwInitEvents() {
    dwInitScroll();
    dwInitCartPage();
    dwInitPhoneLinks();
    dwInitEmailLinks();
    dwInitDrugWidget();
    dwInitExternalLinks();
    dwInitKooperationspartnerLinks();
    dwInitPresseLinks();
    dwInitNewsletterSignup();
    dwInitYouTubeVideoTracking();
  }

  // Scroll-Tracking (nur Analytics)
  function dwInitScroll() {
    if (!analyticsOk()) return;
    var milestones = [25, 50, 75, 90];
    var tracked = {};
    var maxScroll = 0;
    var timeout;
    function pct() {
      var h = document.documentElement, b = document.body;
      return ((h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100;
    }
    function handle() {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        maxScroll = Math.max(maxScroll, Math.round(pct()));
        milestones.forEach(function (m) {
          if (maxScroll >= m && !tracked[m]) {
            tracked[m] = true;
            gtag("event", "scroll", { percent_scrolled: m });
          }
        });
      }, 100);
    }
    window.addEventListener("scroll", handle, { passive: true });
  }

  // Warenkorbseite
  function dwInitCartPage() {
    var cl = document.body.classList;
    var isCart = cl.contains("template-cart") || cl.contains("template_cart") || window.location.pathname.replace(/\/$/, "").endsWith("/cart");
    if (!isCart || !analyticsOk()) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        gtag("event", "view_cart", {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: cart.items.map(function (item) {
            return {
              item_id: item.id.toString(),
              item_name: item.product_title,
              item_variant: item.variant_title || "",
              price: item.price / 100,
              quantity: item.quantity
            };
          }),
          URL: window.location.pathname,
          Titel: document.title
        });
      })
      .catch(function () {});
  }

  function linkFromEvent(event) {
    var link = event.target && event.target.closest ? event.target.closest("a") : null;
    return link && link.href ? link : null;
  }

  // Telefon-Links
  function dwInitPhoneLinks() {
    document.addEventListener("click", function (event) {
      var link = linkFromEvent(event);
      if (!link || !link.href.toLowerCase().startsWith("tel:")) return;
      try {
        if (analyticsOk()) gtag("event", "contact", { phone: window.location.pathname });
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/pNxOCIOM9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("track", "Contact");
        }
      } catch (e) {}
    });
  }

  // Mail-Links
  function dwInitEmailLinks() {
    document.addEventListener("click", function (event) {
      var link = linkFromEvent(event);
      if (!link || !link.href.toLowerCase().startsWith("mailto:")) return;
      try {
        if (analyticsOk()) gtag("event", "contact", { mail: window.location.pathname });
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/OYryCIaM9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("track", "Contact");
        }
      } catch (e) {}
    });
  }

  // MedikamenteCheck-Widget (postMessage)
  function dwInitDrugWidget() {
    window.addEventListener("message", function (event) {
      if (!event.data || !event.data.Result) return;
      var result = event.data.Result;
      if (result !== "WATCH_OUT" && result !== "OK") return;
      try {
        if (analyticsOk()) {
          gtag("event", "analysis_finished", { Ergebnis: result, page: window.location.pathname });
        }
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/gcGwCISZ9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") {
            window.fbq("trackCustom", "Analyse durchgeführt", { Ergebnis: result, URL: window.location.pathname, Titel: document.title });
          }
        }
      } catch (e) {}
    });
  }

  // Externe Links + Login-Portal
  function dwInitExternalLinks() {
    document.addEventListener("click", function (event) {
      var link = linkFromEvent(event);
      if (!link) return;
      var href = link.href;
      try {
        var url = new URL(href);
        if (!/^https?:$/.test(url.protocol)) return;
        var domain = url.hostname.replace("www.", "");
        if (!domain.includes("permedio-genetik.com") && analyticsOk()) {
          gtag("event", "link_click", { URL: href, Titel: document.title });
        }
        if (href === "https://pgx.permedio.at/Account/Login" && marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/ceeHCICM9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("track", "CompleteRegistration");
        }
      } catch (e) {}
    });
  }

  function mailOrTel(href) {
    var h = href.toLowerCase();
    return h.startsWith("mailto:") || h.startsWith("tel:");
  }

  // Kooperationspartner-Seite
  function dwInitKooperationspartnerLinks() {
    if (window.location.pathname !== "/pages/kooperationspartner") return;
    document.addEventListener("click", function (event) {
      var link = linkFromEvent(event);
      if (!link || !mailOrTel(link.href)) return;
      try {
        if (analyticsOk()) gtag("event", "partner_request", { URL: window.location.pathname, Titel: document.title });
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/AbiMCImM9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("trackCustom", "Partneranfrage");
        }
      } catch (e) {}
    });
  }

  // Presse-Seite
  function dwInitPresseLinks() {
    if (window.location.pathname !== "/pages/presse") return;
    document.addEventListener("click", function (event) {
      var link = linkFromEvent(event);
      if (!link || !mailOrTel(link.href)) return;
      try {
        if (analyticsOk()) gtag("event", "press", { URL: window.location.pathname, Titel: document.title });
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/AbiMCImM9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("trackCustom", "Presse");
        }
      } catch (e) {}
    });
  }

  // Newsletter (Symmetry: customer-Form mit contact[tags] = "prospect,newsletter")
  function dwInitNewsletterSignup() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      var isNewsletter = (tags && /newsletter/i.test(tags.value)) || form.classList.contains("newsletter-form") || !!form.closest(".signup-form");
      if (!isNewsletter) return;
      if (typeof form.checkValidity === "function" && !form.checkValidity()) return;
      try {
        if (analyticsOk()) gtag("event", "newsletter", { URL: window.location.pathname, Titel: document.title });
        if (marketingOk()) {
          gtag("event", "conversion", { send_to: "AW-11341536800/I5f0CP2L9esaEKC8iKAq" });
          if (typeof window.fbq !== "undefined") window.fbq("track", "Subscribe");
        }
      } catch (e) {}
    }, true);
  }

  // YouTube-Video-Tracking (alle eingebetteten YouTube-iframes)
  function dwInitYouTubeVideoTracking() {
    if (!analyticsOk()) return;
    var tracked = [];

    function ensureApi(cb) {
      if (window.YT && window.YT.Player) return cb();
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
      (function wait() {
        if (window.YT && window.YT.Player) cb(); else setTimeout(wait, 500);
      })();
    }

    function handleIframe(iframe) {
      if (tracked.indexOf(iframe) !== -1) return;
      if (!iframe.src || !/youtube(-nocookie)?\.com\/embed/.test(iframe.src)) return;
      tracked.push(iframe);
      if (iframe.src.indexOf("enablejsapi=1") === -1) {
        iframe.src += (iframe.src.indexOf("?") === -1 ? "?" : "&") + "enablejsapi=1";
      }
      ensureApi(function () { setup(iframe); });
    }

    function setup(iframe) {
      var interval = null, started = false, completed = false, title = "", duration = 0;
      var milestones = [10, 25, 50, 75], done = {};
      function payload(p) {
        return { URL: window.location.pathname, Titel: document.title, video_url: iframe.src, video_provider: "youtube", video_title: title, video_duration: duration, video_percent: p, video_visible: true };
      }
      var player = new window.YT.Player(iframe, {
        events: {
          onReady: function (e) {
            try { title = e.target.getVideoData().title || ""; duration = e.target.getDuration() || 0; } catch (x) {}
          },
          onStateChange: function (e) {
            try { title = player.getVideoData().title || title; duration = player.getDuration() || duration; } catch (x) {}
            if (e.data === window.YT.PlayerState.PLAYING) {
              if (!started) { started = true; gtag("event", "video_start", payload(0)); }
              if (!interval) {
                interval = setInterval(function () {
                  try {
                    var p = duration > 0 ? Math.round((player.getCurrentTime() / duration) * 100) : 0;
                    milestones.forEach(function (m) {
                      if (p >= m && !done[m]) { done[m] = true; gtag("event", "video_progress", payload(m)); }
                    });
                  } catch (x) {}
                }, 1000);
              }
            } else {
              if (interval) { clearInterval(interval); interval = null; }
              if (e.data === window.YT.PlayerState.ENDED && !completed) {
                completed = true;
                gtag("event", "video_complete", payload(100));
              }
            }
          }
        }
      });
    }

    document.querySelectorAll("iframe").forEach(handleIframe);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.tagName === "IFRAME") handleIframe(n);
          else if (n.querySelectorAll) n.querySelectorAll("iframe").forEach(handleIframe);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
